import { ComponentMap } from '@cinch-nx/data-storyblok'
import { AuthorByline } from './blocks/author-byline/author-byline'

export const storyblokComponents: ComponentMap = {
  AuthorByline: AuthorByline,
}
